module.exports = __webpack_public_path__ + "img/profile-original.65adb1f5.jpg";